import { render } from "./AppContent.vue?vue&type=template&id=275502cc&scoped=true"
const script = {}

import "./AppContent.vue?vue&type=style&index=0&id=275502cc&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-275502cc"]])

export default __exports__